import { get } from 'lodash-es';
import { InventoryModel } from 'client/data/models/inventory';
import { buildMMYSubmodelTypeAmountsPath, InventoryAggregateModel } from 'client/data/models/inventory-aggregate';
import { buildUsedTmvPricingPath, getUsedBaseStylePath, VehicleModel } from 'client/data/models/vehicle-v2';
import { VisitorModel } from 'client/data/models/visitor';
import { isUnknownZip } from 'site-modules/shared/utils/location';

export function getUsedVehiclePriceRange({ submodelAmounts, usedTmv, submodelSlug }) {
  const priceRange = {};
  const submodelPriceRange = get(submodelAmounts, `priceRanges["${submodelSlug}"]`);
  if (get(submodelPriceRange, 'min') && get(submodelPriceRange, 'max')) {
    priceRange.min = submodelPriceRange.min;
    priceRange.max = submodelPriceRange.max;
  } else if (get(usedTmv, 'min') && get(usedTmv, 'max')) {
    priceRange.min = usedTmv.min;
    priceRange.max = usedTmv.max;
  }

  return {
    min: Math.max(priceRange?.min ?? 0, 0),
    max: Math.max(priceRange?.max ?? 0, 0),
  };
}
export function getUsedVehiclePriceRangeFromTrim({ submodelAmounts, trim, usedTmv, submodelSlug }) {
  if (get(trim, 'minPrice') && get(trim, 'maxPrice')) {
    return {
      min: trim.minPrice,
      max: trim.maxPrice,
    };
  }

  return getUsedVehiclePriceRange({ submodelAmounts, usedTmv, submodelSlug });
}

export function getUsedVehiclePriceRangeFromModelState({ modelState, params, submodelSlug }) {
  const searchResults = modelState.get('searchResults', InventoryModel);
  const inventoryPricing = modelState.get(
    buildMMYSubmodelTypeAmountsPath({ ...params, isUsed: true }),
    InventoryAggregateModel
  );

  let priceRange = Object.values(get(inventoryPricing, `priceRanges[${submodelSlug}]`, { a: 0 }));

  const isInternational = isUnknownZip(modelState.get(`location`, VisitorModel));
  const inventoryTotalNumber = get(searchResults, 'inventories.totalNumber', 0);

  if (isInternational || inventoryTotalNumber <= 1) {
    const usedBaseStyleId = modelState.get(`${getUsedBaseStylePath(params)}.usedDefaultStyle.id`, VehicleModel);

    if (usedBaseStyleId) {
      const usedTmv = modelState.get(buildUsedTmvPricingPath(usedBaseStyleId), VehicleModel);
      priceRange = [
        Math.max(get(usedTmv, 'ROUGH.Current.totalWithOptions.usedTmvRetail', 0), 0),
        Math.max(get(usedTmv, 'OUTSTANDING.Current.totalWithOptions.usedTmvRetail', 0), 0),
      ];
    }
  }

  return priceRange;
}
